module.exports = __webpack_public_path__ + "static/media/sence3.5838e1e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_inspection/sence3.png
// module id = 557
// module chunks = 0